import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/NC-Logo_white.png'
import _imports_1 from '../../assets/location_icon.svg'
import _imports_2 from '../../assets/telephone_icon.svg'
import _imports_3 from '../../assets/fax-icon.svg'
import _imports_4 from '../../assets/mail-icon.svg'
import _imports_5 from '../../assets/linkedin_logo.png'
import _imports_6 from '../../assets/facebook-circle-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-07d6ae37"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "page-footer",
  class: "text-white"
}
const _hoisted_2 = { class: "flex flex-col mx-auto w-body-width max-w-body-width justify-between hd:flex-row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex h-full border-b-standard border-border mb-lg hd:mr-md full-hd:mr-xl hd:pr-md hd:border-b-0 hd:w-1/4 hd:border-r-standard" }, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "footer-logo",
    class: "my-auto w-full",
    src: _imports_0,
    alt: "firmenlogo"
  })
], -1))
const _hoisted_4 = { class: "flex border-b-standard border-border flex-col px-2 flex-grow pb-lg mb-lg hd:pb-0 hd:mb-0 hd:border-none" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mt-0 mx-0 mb-lg text-white uppercase" }, "Kontakt", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex mb-standard" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "footer-icon-container" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      class: "footer-icon"
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Industriestrasse 26"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("8404 Winterthur, Schweiz")
  ])
], -1))
const _hoisted_7 = {
  key: 0,
  class: "flex"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "footer-icon"
  })
], -1))
const _hoisted_9 = {
  key: 1,
  class: "flex"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "footer-icon"
  })
], -1))
const _hoisted_11 = {
  key: 2,
  class: "flex"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    class: "footer-icon"
  })
], -1))
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "flex flex-col border-b-standard border-border px-2 flex-grow pb-lg mb-lg hd:pb-0 hd:mb-0 hd:border-none" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mt-0 mx-0 mb-lg text-white uppercase" }, " Über uns ", -1))
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "flex flex-col px-2 flex-grow" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mt-0 mx-0 mb-lg text-white uppercase" }, " Rechtliches ", -1))
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-lg border-t-standard border-border pt-lg hd:border-none hd:mt-0 hd:pt-0 hd:mt-auto hd:flex\" data-v-07d6ae37><h3 class=\"mb-lg hd:my-auto ml-0 mr-md text-white uppercase\" data-v-07d6ae37> Folgen Sie uns: </h3><div class=\"flex mb-lg hd:mb-0\" data-v-07d6ae37><a class=\"mr-md\" href=\"https://www.linkedin.com/company/netconnect-ag\" target=\"_blank\" data-v-07d6ae37><img class=\"h-lg hd:mr-md\" src=\"" + _imports_5 + "\" alt=\"linkedin logo\" data-v-07d6ae37></a><a href=\"https://www.facebook.com/netconnect-AG-101939378246035\" target=\"_blank\" data-v-07d6ae37><img class=\"h-lg\" src=\"" + _imports_6 + "\" alt=\"facebook logo\" data-v-07d6ae37></a></div></div>", 1)
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-footer" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mx-auto my-auto text-primary-contrast" }, " Copyright 2022 © netconnect. All rights reserved ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactItems, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["flex flex-col", { 'mb-md': index < _ctx.contactItems.length - 1 }]),
              key: item.ID
            }, [
              (item.acf.phone)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("p", null, "Tel: " + _toDisplayString(item.acf.phone), 1)
                  ]))
                : _createCommentVNode("", true),
              (item.acf.fax)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("p", null, "Fax: " + _toDisplayString(item.acf.fax), 1)
                  ]))
                : _createCommentVNode("", true),
              (item.acf.email)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _hoisted_12,
                    (item.acf.email)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: `mailto:${item.acf.email}`
                        }, _toDisplayString(item.acf.email), 9, _hoisted_13))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerAboutItems, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.ID
            }, [
              (item.type === 'custom')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: item.url,
                    target: "_blank",
                    class: "hover:underline hover:text-primary"
                  }, _toDisplayString(item.title), 9, _hoisted_16))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: item.url.replace(/^https:\/\/wpdev.netconnect.ch/, ''),
                    class: "hover:underline hover:text-primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
            ], 64))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerLegalItems, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.ID
            }, [
              (item.type === 'custom')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: item.url,
                    target: "_blank",
                    class: "hover:underline hover:text-primary"
                  }, _toDisplayString(item.title), 9, _hoisted_19))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: item.url.replace(/^https:\/\/wpdev.netconnect.ch/, ''),
                    class: "hover:underline hover:text-primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
            ], 64))
          }), 128)),
          _hoisted_20
        ])
      ])
    ]),
    _hoisted_21
  ], 64))
}